import React from 'react';

interface NVPrintConfigurationProps {
    configuration: {
        BaseUrl?: string;
        Token?: string;
        Timeout?: number;
        CompanyId?: string;
        DogovorId?: string;
        StoreId?: string;
        Warehouses?: string;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface NVPrintConfigurationComponent extends React.FC<NVPrintConfigurationProps> {
    configFields: string[];
}

const NVPrintConfiguration: NVPrintConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🌐</span>
                    Базовый URL
                </label>
                <div className="input-group-custom">
                    <input
                        type="url"
                        className="form-input-custom"
                        value={configuration.BaseUrl || ''}
                        onChange={(e) => onChange('BaseUrl', e.target.value)}
                        placeholder="https://api.nvprint.example.com"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🔑</span>
                    Токен авторизации
                </label>
                <div className="input-group-custom">
                    <input
                        type="password"
                        className="form-input-custom"
                        value={configuration.Token || ''}
                        onChange={(e) => onChange('Token', e.target.value)}
                        placeholder="Введите токен"
                        disabled={disabled}
                        autoComplete='new-password'
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">⏱️</span>
                    Таймаут (секунды)
                </label>
                <div className="input-group-custom">
                    <input
                        type="number"
                        className="form-input-custom"
                        value={configuration.Timeout || ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            onChange('Timeout', value ? parseInt(value) : '');
                        }}
                        min="1"
                        placeholder="30"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🏢</span>
                    Company ID
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.CompanyId || ''}
                        onChange={(e) => onChange('CompanyId', e.target.value)}
                        placeholder="Идентификатор компании"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">📋</span>
                    Dogovor ID
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.DogovorId || ''}
                        onChange={(e) => onChange('DogovorId', e.target.value)}
                        placeholder="Идентификатор договора"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🏪</span>
                    Store ID
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.StoreId || ''}
                        onChange={(e) => onChange('StoreId', e.target.value)}
                        placeholder="Идентификатор магазина"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
NVPrintConfiguration.configFields = ['BaseUrl', 'Token', 'Timeout', 'CompanyId', 'DogovorId', 'StoreId'];

export default NVPrintConfiguration;
